import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
// import util from 'util';
import constClass from '../../Constants/Constants';
import { useToasts } from 'react-toast-notifications';
import moment from 'moment';
import { useHistory, useParams, generatePath, } from 'react-router';

const AppLotteryBonus = (props) => {
  const { user } = props;
  const { siteId, mallId } = useParams();
  const [bonusData, setBonusData] = useState(null);
  const [appLotteryData, setAppLotteryData] = useState(null);
  const [ticketData, setTicketData] = useState(null);
  const [lockData, setLockData] = useState(false);
  const { addToast } = useToasts();
  const history = useHistory();

  const [values, setValues] = useState({
    bonus_id: null,
    point: null,
    ticket_id: null,
    parsent: null,
    limit_count: null,
    ticket_expire_date: moment().format('YYYYMMDD'),
    bonus_type: constClass.BONUS_TYPE.POINT,
  });

  const [searchData, setSearchData] = useState({
    bonus_type: '',
  });

  const refreshData = useCallback(async () => {
    const jwt = localStorage.getItem('jwt');
    var applotterydata = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/applottery/backyard/${siteId}/${mallId}`, {
      headers: {
        Authorization: `Bearer ${jwt}`
      }
    })).data;

    var bonusData = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/applotterybonus/${siteId}/${mallId}`, {
      headers: {
        Authorization: `Bearer ${jwt}`,
      }
    })).data;

    var ticketData = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/ticket/${siteId}/${mallId}`, {
      headers: {
        Authorization: `Bearer ${jwt}`,
      }
    })).data;

    setTicketData(ticketData.filter(item => item.ticket_type === constClass.TICKET_TYPE.FREE && item.limit_issue_flag === constClass.FLAG.ON));
    searchData.bonus_type && (bonusData = bonusData.filter(t => Number(t.bonus_type) === Number(searchData.bonus_type)));
    setBonusData(bonusData);

    setAppLotteryData(applotterydata);
  }, [siteId, mallId, searchData]);

  /* 編集ボタン押下 */
  const handleUpdateClick = (data) => {
    const temp = data;
    setValues(temp);
  }

  /* RESETボタン押下 */
  const handleResetClick = () => {
    setValues({
      bonus_id: null,
      point: null,
      ticket_id: null,
      parsent: null,
      limit_count: null,
      ticket_expire_date: moment().format('YYYYMMDD'),
      bonus_type: constClass.BONUS_TYPE.POINT,
    });
  }

  /* DB更新 */
  const handleRegistClick = async (data) => {
    // const sum_limit_count = bonusData.reduce((prev, s) => prev + s.limit_count, 0);
    if ((data.bonus_type === constClass.BONUS_TYPE.TICKET || data.bonus_type === constClass.BONUS_TYPE.BOTH) && !data.ticket_id) {
      window.alert('配布クーポンを選択してください。');
      return;
    }
    if (!data.parsent) {
      window.alert('当選確率を入力してください。');
      return;
    }
    if (!data.limit_count) {
      window.alert('当選上限数を入力してください。');
      return;
    }
    if ((data.bonus_type === constClass.BONUS_TYPE.TICKET || data.bonus_type === constClass.BONUS_TYPE.BOTH) && !data.ticket_expire_date) {
      window.alert('クーポン有効期限を入力してください。');
      return;
    }
    if (data.bonus_id) {
      // 編集時は、現在のデータを除外して計算する
      const idx = bonusData.findIndex(d => d.bonus_id === data.bonus_id);
      if (idx !== -1) bonusData.splice(idx, 1);
    }
    const sum_parsent = bonusData.reduce((prev, s) => prev + s.parsent, 0);
    if (100 < Number(sum_parsent) + Number(data.parsent)) {
      window.alert('当選確率100%を超えています。');
      return;
    }
    if (!window.confirm(`登録してよろしいですか？`)) {
      return;
    }

    const jwt = localStorage.getItem('jwt');
    var params = data;
    params.ins_name = user.userId;
    params.upd_name = user.userId;
    params.site_id = siteId;
    params.mall_id = mallId;
    if (data.ticket_id) params.ticket_id = Number(params.ticket_id);
    if (data.bonus_type === constClass.BONUS_TYPE.TICKET) {
      params.point = null;
    }
    if (data.bonus_type === constClass.BONUS_TYPE.POINT) {
      params.ticket_id = null;
      params.ticket_expire_date = null;
    }


    let res;
    try {
      setLockData(true);
      if (params.bonus_id === null || params.bonus_id === "") {
        res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/applotterybonus/`, params, {
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        });
      } else {
        res = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/applotterybonus/${params.bonus_id}`, params, {
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        });
      }
    } catch (err) {
      console.log(err);
      if (err.response.data !== null) {
        addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      if (!res) {
      } else if (res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast('登録しました。', { appearance: 'success', autoDismiss: true });
        await refreshData();
      }
      setLockData(false);
      handleResetClick();
    }
  }

  /* DB削除 */
  const handleDeleteClick = async (data) => {
    const jwt = localStorage.getItem('jwt');

    if (!window.confirm(`特典ID[${data.bonus_id}]を削除します。よろしいですか？`)) {
      return;
    }
    const params = {
      site_id: siteId,
      bonus_id: data.bonus_id,
      upd_date: data.upd_date
    };
    let res;
    try {
      setLockData(true);
      res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/applotterybonus/delete/`, params, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        }
      });
    } catch (err) {
      if (err.response.data !== null) {
        addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      if (res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast('削除しました。', { appearance: 'success', autoDismiss: true });
        await refreshData();
      }
      setLockData(false);
      handleResetClick();
    }
  }

  const renderUpdateButton = (data) => {
    return (
      <button
        className={`btn btn-primary mx-1`}
        onClick={() => handleUpdateClick(data)}>
        編集
      </button>
    )
  }

  const renderRegistButton = (data) => {
    return (
      <button type="button"
        disabled={lockData}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleRegistClick(data)}>
        登録
      </button>
    )
  }

  const renderDeleteButton = (data) => {
    return (
      <button type="button"
        disabled={lockData || data.bonus_id === null}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleDeleteClick(data)}>
        削除
      </button>
    )
  }

  const renderResetButton = () => {
    return (
      <button type="button"
        disabled={false}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleResetClick()}>
        リセット
      </button>
    )
  }

  const handleChange = (e) => {
    const target = e.target;
    const value = target.type === "checkbox" ? (target.checked ? constClass.FLAG.ON : constClass.FLAG.OFF) : target.value;
    const name = target.name;
    setValues({ ...values, [name]: value });
  }

  const handleSearchChange = (e) => {
    const target = e.target;
    const value = target.type === "checkbox" ? (target.checked ? constClass.FLAG.ON : constClass.FLAG.OFF) : target.value;
    const name = target.name;
    setSearchData({ ...searchData, [name]: value });
  }

  useEffect(() => {
    refreshData();
  }, [refreshData]); //

  const renderInput = () => {
    return (
      <div className="mx-1">
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <span>特典ID</span>
          </div>
          <div className="col-2 text-center align-self-center">
            <input type="text" className="form-control" name="bonus_id" defaultValue={values.bonus_id || ''} placeholder="新規" readOnly />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="bonus_type">ボーナス区分</label>
          </div>
          <div className="col-5">
            <select className="form-control" id="bonus_type" name="bonus_type" value={values.bonus_type} onChange={handleChange}>
              <option key={constClass.BONUS_TYPE_NAME.POINT} value={constClass.BONUS_TYPE.POINT}>{constClass.BONUS_TYPE_NAME.POINT}</option>
              <option key={constClass.BONUS_TYPE_NAME.TICKET} value={constClass.BONUS_TYPE.TICKET}>{constClass.BONUS_TYPE_NAME.TICKET}</option>
              <option key={constClass.BONUS_TYPE_NAME.BOTH} value={constClass.BONUS_TYPE.BOTH}>{constClass.BONUS_TYPE_NAME.BOTH}</option>
            </select>
          </div>
        </div>
        {(values.bonus_type === constClass.BONUS_TYPE.TICKET || values.bonus_type === constClass.BONUS_TYPE.BOTH) &&
          <div className="row mb-3">
            <div className="col-2 text-center align-self-center">
              <label htmlFor="ticket_id">配布クーポン</label>
            </div>
            <div className="col-5">
              <select className="form-control" id="ticket_id" name="ticket_id" value={values.ticket_id || ''} onChange={handleChange}>
                <option value="">- 選択 -</option>
                {ticketData && ticketData.map((ticket) => (
                  <option key={ticket.ticket_id} value={ticket.ticket_id}>
                    {ticket.ticket_name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        }
        {(values.bonus_type === constClass.BONUS_TYPE.POINT || values.bonus_type === constClass.BONUS_TYPE.BOTH) &&
          <div className="row mb-3">
            <div className="col-2 text-center align-self-center">
              <span>付与ポイント</span>
            </div>
            <div className="col-5 text-center align-self-center">
              <input type="text" className="form-control" name="point" value={values.point || ''} onChange={handleChange} placeholder="付与ポイントを入力してください" />
            </div>
            <div className="col-5 align-self-center">
              ※ポイントの有効期限は翌年の12月31日までとなります。
            </div>
          </div>
        }
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="parsent">当選確率%</label>
          </div>
          <div className="col-5 align-self-center">
            <input type="text" className="form-control" name="parsent" id="parsent" value={values.parsent || ''} placeholder="当選確率％を入力してください" onChange={handleChange}></input>
          </div>
          <div className="col-5 align-self-center">
            ※当選確率の合計が100％を超えないようにしてください。
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="limit_count">当選上限数</label>
          </div>
          <div className="col-5 align-self-center">
            <input type="text" className="form-control" name="limit_count" id="limit_count" value={values.limit_count || ''} placeholder="当選上限数を入力してください" onChange={handleChange}></input>
          </div>
        </div>
        {(values.bonus_type === constClass.BONUS_TYPE.TICKET || values.bonus_type === constClass.BONUS_TYPE.BOTH) &&
          <div className="row mb-3">
            <div className="col-2 text-center align-self-center">
              <label htmlFor="ticket_expire_date">クーポン有効期限日</label>
            </div>
            <div className="col-5 text-center align-self-center">
              <input type="text" className="form-control" name="ticket_expire_date" value={values.ticket_expire_date ? values.ticket_expire_date.replace(/-/g, "") : ""} onChange={handleChange} placeholder="YYYYMMDD" />
            </div>
          </div>
        }
        <div className="row mb-2 pb-4 d-flex justify-content-center mt-4">
          <div className="col-3 text-center">
            {renderRegistButton(values)}
          </div>
          <div className="col-3 text-center">
            {renderDeleteButton(values)}
          </div>
          <div className="col-3 text-center">
            {renderResetButton(values)}
          </div>
        </div>
      </div>
    );
  }

  const renderList = () => {
    return (
      <div className="row mb-3 p-0 mt-2">
        <div className="col-12 my-3">
          <button
            type="button"
            className="btn text-black bg-lightwhite border-black"
            onClick={() => history.push(generatePath(`${props.match.path}applottery/`, { siteId: props.match.params.siteId, mallId: props.match.params.mallId }))}>
            戻る
          </button>
        </div>
        <div className="mr-1 text-center align-self-center">
          <span>ボーナス区分</span>
        </div>
        <div className="col-12 mb-2">
          <div className="row">
            <select className="col-2 custom-select w-100 text-left" aria-label="ボーナス区分" name="bonus_type" value={searchData.bonus_type || ''} onChange={handleSearchChange}>
              <option value="">選択してください</option>
              <option key={constClass.BONUS_TYPE_NAME.POINT} value={constClass.BONUS_TYPE.POINT}>{constClass.BONUS_TYPE_NAME.POINT}</option>
              <option key={constClass.BONUS_TYPE_NAME.TICKET} value={constClass.BONUS_TYPE.TICKET}>{constClass.BONUS_TYPE_NAME.TICKET}</option>
              <option key={constClass.BONUS_TYPE_NAME.BOTH} value={constClass.BONUS_TYPE.BOTH}>{constClass.BONUS_TYPE_NAME.BOTH}</option>
            </select>
          </div>
        </div>
        <div className="col-12 p-0">
          <table className="table table-bordered table-striped">
            <thead className={`table-info`}>
              <tr>
                <td className="text-center align-middle">
                  特典ID
                </td>
                <td className="text-center align-middle">
                  ボーナス区分
                </td>
                <td className="text-center align-middle">
                  当選確率
                </td>
                <td className="text-center align-middle">
                  当選上限数
                </td>
                <td className="text-center align-middle">
                  処理
                </td>
              </tr>
            </thead>
            <tbody>
              {bonusData.map((data, idx) => (
                <tr key={data.bonus_id}>
                  {/* 特典ID */}
                  <td className="text-center align-middle">
                    {data.bonus_id}
                  </td>
                  {/* ボーナス区分 */}
                  <td className="text-center align-middle">
                    {constClass.BONUS_TYPE_NAME[data.bonus_type]}
                  </td>
                  {/* 当選確率 */}
                  <td className="text-center align-middle">
                    {data.parsent ? data.parsent + '%' : '0%'}
                  </td>
                  {/* 当選上限数 */}
                  <td className="text-center align-middle">
                    {data.limit_count ? data.limit_count + '人' : '0人'}
                  </td>
                  {/* 処理 */}
                  <td className="text-center align-middle text-nowrap">
                    {renderUpdateButton(data)}
                  </td>
                </tr>
              ))
              }
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      {bonusData === null && appLotteryData === null && <div className="row"><div className="col-12">読み込み中・・・</div></div>}
      {bonusData !== null && appLotteryData !== null && (renderList())}
      {renderInput()}
    </div>
  )
}

export default AppLotteryBonus;